// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"39043f7a","389":"d6957e48","455":"2ef81b10","977":"e24bcad4"}[chunkId] + ".chunk.js";
};